import { SETTINGS_LIST_VIEW } from "@/features/settings-account/routes/route-list.ts"

export const RESET_PASSWORD_VIEW = SETTINGS_LIST_VIEW + "/reset-password"
export const LOGIN_SCREEN = "/login"
export const LOST_PASSWORD_SCREEN = "/password"
export const SIGNUP_SCREEN = "/signup"
export const REQUEST_ACCESS_SCREEN = "/request-access"
export const PASSWORD_RESET_CONFIRM_SCREEN = "/account/password-reset/key/:key"
export const EMAIL_VERIFICATION_SCREEN = "/account/verify-email/:key"
export const ONBOARDING_SCREEN = "/onboarding"
